module.exports = __webpack_public_path__ + "static/media/koffie.52bfb782.jpg";